import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_id,
    },
    pause: !location_id,
  }
}
